// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BaseTextarea_baseTextareaWrapper_3W7q-{width:100%;margin-bottom:20px}.BaseTextarea_baseTextarea_2l-ol{width:100%;color:#363636;padding-top:9px;padding-left:21px;font-family:inherit;font-size:18px;border:2px solid #d2d2d2}.BaseTextarea_baseTextareaNewDesign_2SZuv{border:2px solid #adb1ab}.BaseTextarea_baseTextarea_2l-ol:focus{outline:none;border:2px solid #9cbc76}.BaseTextarea_baseTextareaNewDesign_2SZuv:focus{outline:none;border:2px solid #4b6e5a}.BaseTextarea_baseTextarea_2l-ol::-webkit-input-placeholder{color:#a9a9a9}.BaseTextarea_invalid_3G9Y9{border:2px solid #bc7979}", ""]);
// Exports
exports.locals = {
	"baseTextareaWrapper": "BaseTextarea_baseTextareaWrapper_3W7q-",
	"baseTextarea": "BaseTextarea_baseTextarea_2l-ol",
	"baseTextareaNewDesign": "BaseTextarea_baseTextareaNewDesign_2SZuv",
	"invalid": "BaseTextarea_invalid_3G9Y9"
};
module.exports = exports;
